import { render, staticRenderFns } from "./share-setting.vue?vue&type=template&id=1fa46e66&scoped=true&"
import script from "./share-setting.vue?vue&type=script&lang=js&"
export * from "./share-setting.vue?vue&type=script&lang=js&"
import style0 from "./share-setting.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./share-setting.vue?vue&type=style&index=1&id=1fa46e66&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa46e66",
  null
  
)

export default component.exports